/** @jsx h */
import { h } from 'preact'

/**
 * A wrapper around <details> for DRY analytics
 */
const Details = ({
  analyticsContext,
  analyticsName,
  analyticsSubject,
  analyticsVersion = 2,
  children,
  className = 'Details'
}) =>
  <details
    class={className}
    type={analyticsName}
    data-controller='analytics'
    data-action='analytics#click'
    data-analytics-label-value={analyticsContext}
    data-analytics-name-value={analyticsName}
    data-analytics-subject-value={analyticsSubject}
    data-analytics-version-value={analyticsVersion}
  >
    {children}
  </details>

export default Details
